export default __webpack_public_path__ + "static/media/icons-manage-documents.30e3ff84.svg";